import React, { useEffect, useState } from 'react';
import { Header } from '../../../header/Header';
import MainSider from '../sider/MainSider/MainSider';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import * as S from './MainLayout.styles';
import { Outlet, useLocation } from 'react-router-dom';
import { DASHBOARD_PATH } from '@app/components/router/AppRouter';
import { useResponsive } from '@app/hooks/useResponsive';
import { References } from '@app/components/common/References/References';
import { AppSettingProvider } from '@app/contexts/AppSettingContext';
import AppBreadcrumb from './AppBreadcrumb';
import { BreadcrumbLabelProvider } from './BreadcrumbContext';
import WhatsNewModal from '@app/components/help/WhatsNewModal';

const MainLayout: React.FC = () => {
  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const { isDesktop } = useResponsive();
  const [siderCollapsed, setSiderCollapsed] = useState(false);
  const location = useLocation();

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  useEffect(() => {
    setIsTwoColumnsLayout([DASHBOARD_PATH].includes(location.pathname) && isDesktop);
  }, [location.pathname, isDesktop]);

  // iPad/tablet (768-1279): sider fixed nhưng content chỉ chừa 80px lề — mặc
  // định thu gọn để không che nội dung; desktop rộng thì mở sẵn.
  useEffect(() => {
    setSiderCollapsed(!isDesktop);
  }, [isDesktop]);

  return (
    <AppSettingProvider>
    <BreadcrumbLabelProvider>
    <S.LayoutMaster>
      <MainSider isCollapsed={siderCollapsed} setCollapsed={setSiderCollapsed} />
      <S.LayoutMain>
        <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
          <Header toggleSider={toggleSider} isSiderOpened={!siderCollapsed} isTwoColumnsLayout={isTwoColumnsLayout} />
          <S.Breadcrumb>
            <AppBreadcrumb />
          </S.Breadcrumb>
        </MainHeader>
        <MainContent id="main-content" $isTwoColumnsLayout={isTwoColumnsLayout}>
          <div className="tw-mx-auto tw-w-full tw-max-w-[1600px]">
            <Outlet />
          </div>
          {!isTwoColumnsLayout && <References />}
        </MainContent>
      </S.LayoutMain>
      <WhatsNewModal />
    </S.LayoutMaster>
    </BreadcrumbLabelProvider>
    </AppSettingProvider>
  );
};

export default MainLayout;
